import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { UserTypeUrlParam, USER_ROLE_KEYS } from 'src/app/shared/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public userProfile: any;
  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();

  private shopPopupLogin: Subject<boolean> = new Subject<any>();
  shopPopupLogin$: Observable<boolean> = this.shopPopupLogin.asObservable();
  customerTokenFound: EventEmitter<void> = new EventEmitter<void>();
  userRoleKey!: USER_ROLE_KEYS;

  private updateSidebarNav: Subject<any> = new Subject<any>();
  updateSidebarNav$: Observable<any> = this.updateSidebarNav.asObservable();

  summitCounter = 0;

  private redirectEmail: any;
  private redirectTo: any;
  private redirectUserType: any;

  constructor(private http: HttpClient) { }

  getData(url: string): Observable<any> {
    return this.http.get(url);
  }

  postDatawithHeaders(url: string, payload: any): Observable<any> {
    return this.http.post(url, { headers: payload })
  }
 
  postDatawithoutHeaders(url: string, payload: any): Observable<any> {
    return this.http.post(url, payload);
  }

  update(url: string, key: string | number, payload: any): Observable<any> {
    return this.http.put(`${url}${key}`, payload);
  }
  patchData(url: string, payload: any): Observable<any> {
    return this.http.patch(url, payload);
  }

  delete(url: string): Observable<any> {
    return this.http.delete(url);
  }

  setData(data:String) {
    this.userProfile = data;
    this.sharedData.next(data);
  }
  getUserName() {
    return this.userProfile;
  }
  checkToken(): void {
    this.customerTokenFound.emit();
  }
  encryptData(data: any) {
    let key = CryptoJS.enc.Utf8.parse('0199933389abcdef0123456789abcdef');
    let iv = CryptoJS.enc.Utf8.parse('abcdef9876543420');
    var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
    return encrypted.toString();
  }

  openLoginComponentPopup(data: boolean) {
    this.shopPopupLogin.next(data);
  }
  updateSideNav(view:String) {
    this.updateSidebarNav.next(view);
  }
  getUrlParams(): any {
    const data = {
      redirectEmail: this.redirectEmail,
      redirectTo: this.redirectTo,
      redirectUserType: this.redirectUserType,
    };
    return data;
  }
  
}
